import { UPDATE_BOOKER_DETAILS } from '../actions/bookerDetails'
import { RESET_FLOW } from '../actions/reset'

export const initialState = {
  salutation: '',
  firstName: '',
  lastName: '',
  emailAddress: '',
  phoneNumber: '',
  countryCode: '',
  company: '',
}

function bookerDetails(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_BOOKER_DETAILS:
      return {
        ...state,
        ...action.data,
      }
    case RESET_FLOW:
      return initialState
    default:
      return state
  }
}

export default bookerDetails
